export default {"src":"/_next/static/media/illustration-heart.e59d36d8.svg","height":120,"width":120};